export enum ValidationError {
  ArrayMax = 'arrayMax',
  ArrayMin = 'arrayMin',
  Custom = 'custom',
  Email = 'email',
  Max = 'max',
  MaxLength = 'maxlength',
  Min = 'min',
  MinLength = 'minlength',
  NIP = 'nip',
  PostCode = 'postCode',
  Required = 'required',
  SelectionMax = 'selectionMax',
  SelectionMin = 'selectionMin',
  URL = 'url',
}
